import React, { PureComponent } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { logout } from '../../store/actions';

class LogoutView extends PureComponent {
  componentDidMount() {
    this.props.logout();
  }

  render() {
    return <Redirect to="/login" />;
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logout,
    },
    dispatch
  );

const enhance = compose(connect(null, mapDispatchToProps));

export default enhance(LogoutView);
